import { create } from 'zustand';

/**
 * Auth Store - Global authentication state
 * Manages user session, login status, and user profile data
 */
export const useAuthStore = create((set, get) => ({
  // State
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,

  // Mock user data for prototype
  mockUser: {
    id: 'user-001',
    email: 'athlete@sportspots.com',
    displayName: 'Alex Athlete',
    firstName: 'Alex',
    lastName: 'Johnson',
    avatar: null,
    bio: 'Basketball enthusiast | Weekend warrior',
    location: 'San Francisco, CA',
    sports: ['basketball', 'soccer', 'tennis'],
    skillLevel: 'intermediate',
    joinedAt: '2024-01-15',
    stats: {
      eventsAttended: 24,
      eventsHosted: 3,
      friendsCount: 47,
      reputation: 4.8,
    },
  },

  // Actions
  login: async (email, password) => {
    set({ isLoading: true, error: null });
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 800));
    
    // Mock validation
    if (email && password) {
      set({
        user: get().mockUser,
        isAuthenticated: true,
        isLoading: false,
        error: null,
      });
      return true;
    }
    
    set({
      isLoading: false,
      error: 'Invalid credentials',
    });
    return false;
  },

  signup: async (userData) => {
    set({ isLoading: true, error: null });
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const newUser = {
      ...get().mockUser,
      ...userData,
      id: `user-${Date.now()}`,
      joinedAt: new Date().toISOString().split('T')[0],
    };
    
    set({
      user: newUser,
      isAuthenticated: true,
      isLoading: false,
      error: null,
    });
    return true;
  },

  logout: () => {
    set({
      user: null,
      isAuthenticated: false,
      error: null,
    });
  },

  updateProfile: (updates) => {
    set((state) => ({
      user: state.user ? { ...state.user, ...updates } : null,
    }));
  },

  clearError: () => set({ error: null }),
}));

export default useAuthStore;
